<template>
  <SysDialog
    v-model="dialog_ativo"
    :largura="450"
    :titulo="etapa === 1 ? 'Resetar senha do usuário' : 'Sucesso!'"
    txt-botao="resetar"
    :ocultar-acoes="etapa > 1"
    @click:primary="resetarSenhaUsuario"
  >
    <template #ativador>
      <v-btn icon @click="dialog_ativo = true">
        <v-icon>mdi-lock-reset</v-icon>
      </v-btn>
    </template>

    <div class="font-14 mt-n2 pb-2">
      <template v-if="etapa === 1">
        <span class="font-weight-medium">Nome:</span> {{ Helpers.primeiraLetraMaiuscula(usuario.name) }}<br/>
        <span class="font-weight-medium">E-mail:</span> {{ usuario.email }}<br/>
      </template>

      <template v-else>
        Nova senha foi enviada para o e-mail <span class="font-weight-medium">{{ usuario.email }}</span>
      </template>
    </div>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog";
import {realizarAlteracaoSenha} from "@/api/usuario";
import {logout} from "@/helpers";

export default {
  name: "ResetarSenhaUsuario",
  components: {
    SysDialog
  },
  props: {
    usuario: Object
  },
  data: () => ({
    dialog_ativo: false,
    etapa: 1
  }),
  watch: {
    dialog_ativo() {
      if (! this.dialog_ativo) {
        setTimeout(() => (this.etapa = 1), 1500);
      }
    }
  },
  methods: {
    resetarSenhaUsuario() {
      this.$store.dispatch(
        "loading/addRequisicao",
        realizarAlteracaoSenha({email: this.usuario.email})
          .then(() => (this.etapa++))
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>

</style>
